export type RecoverOrderOfferTier = "standard" | "offer-2500" | "offer-5000";

const OFFER_2500_MIN_MONTHLY_ORDERS = 1000;
const OFFER_5000_MIN_MONTHLY_ORDERS = 5000;

export function getMonthlyOrderCount(
  team: {
    metricsSnapshot?: {
      totalOrderVolume?: { last30Days?: number };
      onlineStoreOrderVolume?: { last30Days?: number };
    };
  } | null,
): number | null {
  const total = team?.metricsSnapshot?.totalOrderVolume?.last30Days;
  if (typeof total === "number" && Number.isFinite(total)) {
    return total;
  }
  const online = team?.metricsSnapshot?.onlineStoreOrderVolume?.last30Days;
  if (typeof online === "number" && Number.isFinite(online)) {
    return online;
  }
  return null;
}

/** Maps trailing-30-day order volume to Recover non-subscriber offer tier. */
export function getRecoverOrderOfferTier(
  monthlyOrders: number | null,
): RecoverOrderOfferTier {
  if (monthlyOrders == null || monthlyOrders < OFFER_2500_MIN_MONTHLY_ORDERS) {
    return "standard";
  }
  if (monthlyOrders < OFFER_5000_MIN_MONTHLY_ORDERS) {
    return "offer-2500";
  }
  return "offer-5000";
}
